import Utils from '@/core/utils/Utils';
import SWPaymentDestinationsDAO from '@/domains/SWPaymentDestinations/SWPaymentDestinationsDAO';
import SWPaymentDestination from '@/domains/SWPaymentDestinations/SWPaymentDestination';
import PaymentReasonBasis from '@/domains/PaymentRequests/PaymentReasonBasis';
import ProductionSite from '@/domains/ProductionSites/ProductionSite';

/**
 * Сервис назначений платежа
 */
class SWPaymentDestinationsService {

    /**
     * Загружает список назначений платежа
     */
    static async getList(
      filters: Parameters<typeof SWPaymentDestinationsDAO.getList>[0]
    ): Promise<SWPaymentDestination[]> {
        const response = await SWPaymentDestinationsDAO.getList(filters);
        return Utils.hydrateArray(response.data, SWPaymentDestination.fromServer);
    }
}

export default SWPaymentDestinationsService;
